import React, { FC, Fragment } from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { qantasHotels } from 'roo-ui/logos';
import { Container, Flex, Link } from 'roo-ui/components';
import { QH_HOMEPAGE_URL } from '../../../lib/config';
import { QantasUniversalNav } from '../QantasUniversalNav';
import { HeaderProps } from '../types';
import { LoginTooltip } from '../LoginTooltip';
import { useHeaderContext } from '../HeaderContext';
import { NavigationLinks } from './NavigationLinks';
import { QffMenu } from './QffMenu';
import { isArray, last } from 'lodash';

const Logo = styled.img`
  display: inline-flex;
  width: ${rem(186)};
`;

const HeaderInner = styled(Flex)`
  justify-content: space-between;
  align-items: flex-end;

  @media print {
    display: none;
  }
`;

export const HeaderDesktop: FC<HeaderProps> = ({
  universalNavEnabled = true,
  qffLoginEnabled = true,
  homepageUrl = QH_HOMEPAGE_URL,
  homepageLogoSrc = qantasHotels,
  homepageLogoLabel = 'Qantas',
  LogoItemRenderer = Logo,
  navEnabled = true,
  arrowDirection = 'right',
}) => {
  const { onInteraction } = useHeaderContext();

  const tooltipArrowDirection = isArray(arrowDirection)
    ? last(arrowDirection)
    : arrowDirection;

  const trackIteraction = () => {
    onInteraction({ type: 'Desktop Header Logo', value: 'Selected' });
  };

  return (
    <Fragment>
      {universalNavEnabled && <QantasUniversalNav />}
      {navEnabled && (
        <>
          <Container pr={4}>
            <HeaderInner>
              <Link
                href={homepageUrl}
                mr={4}
                my={2}
                p={1}
                data-testid="header-logo-link"
                onClick={trackIteraction}
              >
                <LogoItemRenderer
                  src={homepageLogoSrc}
                  alt={homepageLogoLabel}
                  role="img"
                  aria-label={`${homepageLogoLabel} Logo`}
                />
              </Link>
              {qffLoginEnabled && (
                <Flex
                  data-print-style="hidden"
                  mb={-2}
                  data-testid="desktop-qff-menu"
                >
                  <LoginTooltip arrowDirection={tooltipArrowDirection} />
                  <QffMenu />
                </Flex>
              )}
            </HeaderInner>
          </Container>
          <NavigationLinks />
        </>
      )}
    </Fragment>
  );
};
